<template>
    <settings-editor-base
        v-bind:label="label"
    >
        <div class="row">
            <div class="col-12">
                <slider
                        v-bind:value="value"
                        v-on:change-value="number = $event"
                        v-bind:options="options"
                />
            </div>
            <div class="col-12 text-center">
                <number v-model="number" :suffix="valueSuffix" :max="max" :min="min"/>
            </div>
        </div>
    </settings-editor-base>
</template>

<script>
    import Slider from '../../../../Components/Util/BootstrapSlider.vue';
    import SettingsEditorBase from "./SettingsEditorBase.vue";
    import EditableNumber from '../../../../Components/Util/EditableNumber.vue';

    export default {
        name: "settings-slider",
        components: {
            SettingsEditorBase,
            Slider,
            'number': EditableNumber
        },
        computed: {
            options(){
                const vm = this;
                
                return {
                    min: vm.min,
                    max: vm.max
                }
            }
        },
        watch: {
            number(value) {
                this.$emit('input', value);
            }
        },
        data() {
            return {
                number: this.value
            }
        },
        props: {
            label: {
                type: String,
                required: true
            },
            valueSuffix: {
                type: String
            },
            value: {
                type: Number,
                default: 0
            },
            min: {
                type: Number,
                default: null
            },
            max: {
                type: Number,
                default: null
            }
        }
    };
</script>

<style scoped>
    ::v-deep .slider{
        width: 100%;
    }
</style>
